import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import general from './general'
import auth from './auth'
import socket from './socket'
import team from './team'
import participants from './participants'
import popup from './popup'
import error from './error'
import signup from './signup'
import badges from './badges'
import mentions from './mentions'
import reports from './reports'
import comments from './comments'

export default combineReducers({
  routerReducer,
  general,
  auth,
  socket,
  team,
  participants,
  popup,
  error,
  signup,
  badges,
  mentions,
  reports,
  comments
})



// WEBPACK FOOTER //
// ./src/reducers/index.js